import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse } from '../../model';
import { ICreateNews, INews, IQueryNews } from '../../model/api-modules';
import { ADMIN_PREFIX } from '../config';

// 获取news列表
export const getAdminNewsList = (query?: IQueryNews) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/news`;
      const response = await api.commonRequest('GET', url, query);
      const res = await parsedResponse<{ list: INews[] }>(response, 'data');
      return res?.list || [];
    } catch (error) {
      return [];
    }
  });

// 创建news
export const createNews = (body: ICreateNews) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/news`;
      const response = await api.commonRequest('POST', url, {
        ...body,
        DataSource: 'support',
      });
      const res = await parsedResponse<IAPIresponse>(response, 'code');
      return res;
    } catch (error: any) {
      return error?.apiError;
    }
  });

// 修改news
export const editNews = (body: ICreateNews, id: number) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/news/${id}`;
      const response = await api.commonRequest('PUT', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'code');
      return res;
    } catch (error: any) {
      return error?.apiError;
    }
  });

// 删除news
export const deleteNews = (id: number) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/news/${id}`;
      const response = await api.commonRequest('DELETE', url);
      const res = await parsedResponse<IAPIresponse>(response, 'code');
      return res;
    } catch (error: any) {
      return error?.apiError;
    }
  });
